import { useContext } from 'react';
import { globalContext } from 'context/global';

export default function useGlobal() {
  const state = useContext(globalContext);
  return state;
}
